module.exports = __webpack_public_path__ + "static/carbon-mobile-982ec203be212a90000514e5616186b8.mp4";